(() => {
  const initSliders = () => {
    const slideshows = document.querySelectorAll(
      ".custom-project-slider__slide-container"
    );
    slideshows.forEach((slideshow) => {
      new Swiper(slideshow, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 16,
        observer: true,
        observeParents: true,
        autoHeight: true,
        breakpoints: {
          768: {
            autoHeight: false,
            slidesPerView: 3,
            spaceBetween: 48,
          },
        },
      });
    });
  };
  initSliders();

  document.addEventListener("shopify:section:load", function () {
    initSliders();
  });
})();
